import { Component, OnInit } from '@angular/core';
import {
    AlertModule,
    AlertService,
    ButtonModule,
    ButtonTypes,
    ButtonColors,
    DropdownMenuItem,
    LayerService,
    LayerSize,
    PopupModule,
    PopupService,
    PopupTypes,
} from '@ed---interne/ng-uui-components';
import { SimulationNewNetworkService } from '../../simulation-new-network.service';

@Component({
    selector: 'app-simulate-new-network',
    templateUrl: './simulate-new-network.component.html',
    styleUrl: './simulate-new-network.component.scss',
    standalone: true,
    imports: [ButtonModule],
    providers: [],
})
export class SimulateNewNetworkComponent implements OnInit {
    public buttonColors = ButtonColors;
    public buttonTypes = ButtonTypes;

    public loading = true;
    public isSimulated = false;

    constructor(
        private simulationService: SimulationNewNetworkService,
        private readonly layerService: LayerService,
        private readonly alertService: AlertService,
    ) {}

    ngOnInit(): void {
        this.startSimulation();
    }

    async startSimulation() {
        try {
            await this.simulationService.simulateNewNetwork();
            this.isSimulated = true;
        } catch (err: any) {
            const error = err.message || 'Erreur lors de la simulation';
            console.error('Error startSimulation', error);
            this.alertService.error('Simulation', 'Erreur lors de la simulation');
            this.layerService.close();
        } finally {
            this.loading = false;
        }
    }

    resetSimulation() {
        this.simulationService.resetSimulation();
        this.layerService.close();
    }

    clearXlsxFile() {
        this.simulationService.clearXlsxFile();
        this.layerService.close();
    }
}
